import Dexie, { type EntityTable } from 'dexie';
import {getConfig} from "../../AppConfig";
const { dbversion } = getConfig()

interface dispatch {
    uuid: string; // This prop will be used as primary key (see below)
    json: string;
}

interface documents {
    uuid?: string; // This prop will be used as primary key (see below)
    blobData: Blob;
}

const db = new Dexie(dbversion) as Dexie & {
    dispatch: EntityTable<dispatch, 'uuid'>,
    documents: EntityTable<documents, 'uuid'>,
};

// Schema declaration:
// db.version(2).stores({
//     dispatch: '++uuid, uuid, json'
// });
// Don't touch this version unless you change the schema
db.version(1).stores({
    dispatch: '++uuid, uuid, json'
});

db.version(2).stores({
    dispatch: '++uuid, uuid, json'
});

db.version(3).stores({
    dispatch: '++uuid, uuid, json',
});

db.version(4).stores({
    dispatch: '++uuid, uuid, json',
    documents: '++uuid, uuid, blobData',
});

export type { dispatch };
export { db };